<template>
  <div>
    <v-card-text class="card-text pt-5 pb-1">
      <v-form 
        ref="form"
        @keyup.native.enter="submit"
      >
        <v-text-field
          autofocus
          v-model="email"
          label="Email *"
          :error-messages="emailErrorMessages"
          validate-on-blur
          :rules="[required, validEmail]"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Mật khẩu *"
          :error-messages="passwordErrorMessages"
          :type="passwordShow ? 'text' : 'password'"
          :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordShow = !passwordShow"
          validate-on-blur
          :rules="[required]"
        ></v-text-field>
        <v-text-field
          v-model="passwordConfirm"
          label="Xác nhận mật khẩu *"
          :error-messages="passwordConfirmErrorMessages"
          :type="passwordConfirmShow ? 'text' : 'password'"
          :append-icon="passwordConfirmShow ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordConfirmShow = !passwordConfirmShow"
          validate-on-blur
          :rules="[required, passwordsMatch]"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-progress-circular
        v-show="loading"
        indeterminate
        color="primary"
        size="24"
        width="3"
        class="mr-2"
      ></v-progress-circular>
      <v-btn
        color="primary"
        text
        class="mr-2"
        @click="submit"
      >Đăng ký</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { endpoints } from '@/utils/ApiEndpoints'
import { handle } from '@/utils/ErrorHandling'
import { status } from '@/utils/HttpStatus'
import LoginMixin from './LoginMixin.js'

export default {
  name: 'SignUpForm',

  data: () => ({
    loading: false,

    email: '',
    password: '',
    passwordConfirm: '',

    emailErrorMessages: [],
    passwordErrorMessages: [],
    passwordConfirmErrorMessages: [],

    passwordShow: false,
    passwordConfirmShow: false,

    required: v => v !== '' || 'Thông tin bắt buộc.',
    validEmail: v => /.+@.+\..+/.test(v) || 'Email không hợp lệ.',
  }),

  mixins: [
    LoginMixin,
  ],

  methods: {
    submit () {
      if (!this.$refs.form.validate()) return
      this.loading = true

      this.$axios.post(endpoints.user.crud, {
        email: this.email,
        password: this.password 
      })
        .then(() => {
          this.login(true)
        })
        .catch(error => {
          handle(error, {
            [status.HTTP_400_BAD_REQUEST]: () => {
              for (const [field, errorMessages] of Object.entries(error.response.data)) {
                this[field + 'ErrorMessages'] = errorMessages
              }
            }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    passwordsMatch () {
      return this.password === this.passwordConfirm || 'Mật khẩu không khớp nhau.'
    }
  }
}
</script>

<style scoped>

</style>
